import { useReducer, useRef } from 'react';

function reducer(state, action) {
  return {
    ...state,
    ...action,
  };
}

function useSurvey() {
  const _etc1 = useRef(null);
  const _etc2 = useRef(null);
  const _etc3 = useRef(null);
  const _etc5 = useRef(null);
  const _etc6 = useRef(null);

  const [state, setState] = useReducer(reducer, {
    q1: '',
    q1Etc: '',
    q2: '',
    q2Etc: '',
    q3: '',
    q3Etc: '',
    q4: '',
    q5: '',
    q5Etc: '',
    q6: '',
    q6Etc: '',

    name: '',
    phone: '',
    gender: '',
    agree: false,
  });

  async function onChangeToRadio(e) {
    const { name, value } = e.currentTarget;
    console.log(name, value)
    await setState({
      [name]: +value,
    });

    if (name === 'q1' && +value === 4) {
      _etc1.current.focus();
    } else if (name === 'q2' && +value === 6) {
      _etc2.current.focus();
    } else if (name === 'q3' && +value === 6) {
      _etc3.current.focus();
    } else if (name === 'q5' && +value === 5) {
      _etc5.current.focus();
    } else if (name === 'q6' && +value === 7) {
      _etc6.current.focus();
    }
  }

  return {
    _etc1, _etc2, _etc3, _etc5, _etc6,
    state, onChangeToRadio
  };
}

export default useSurvey;
